var _clipPath, _g, _g2, _g3, _g4, _g5, _tspan, _tspan2, _tspan3, _tspan4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1130 643",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(1.10933,0,0,1.0562,-2.94,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.65,
    y: 0,
    width: 1018.16,
    height: 608.36,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.65,
    y: 0,
    width: 1018.16,
    height: 608.36
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.901444,0,0,0.946793,4.80392,8.02979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M729.794,14.858L475.275,161.805L472.775,157.475L729.794,9.085L823.721,63.313L821.221,67.644L729.794,14.858Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.901444,0,0,0.946793,2.65025,10.1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M727.514,161.143L866.967,241.657L861.984,244.534L717.514,161.143L834.28,93.728L836.78,98.058L727.514,161.143Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.901444,0,0,0.946793,2.64456,9.81211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M927.126,246.844L960.764,227.423L958.264,223.092L922.126,243.957L927.126,246.844Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.907222,0,0,0.948123,0.245885,22.4155)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.993631,0,0,1.02527,2.65025,-10.5415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.051,395.2L9,382.85L9,-9.946",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.49px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25077,0,0,1.2906,-102.959,-7.90252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.5,154.635L570.5,-9.946",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.39px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.993631,0,0,0.998598,2.65025,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.761,518.483L173.761,615.873",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.993631,0,0,0.998598,2.65025,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.136,344.02L551.24,386.958L551.24,615.873",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.993631,0,0,0.998598,2.65025,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.281,286.732L855.686,302.319L855.686,615.873",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.18207,0,0,2.29185,-379.833,-86.4269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.871,178.885L278.855,196.774",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.18207,0,0,2.29185,-379.833,-86.4269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.871,214.663L309.839,250.44L371.806,214.663L371.806,207.187L309.839,171.41L247.871,207.187L247.871,214.663Z",
    style: {
      fill: "rgb(123,31,162)"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.901444,0,0,0.946793,2.65025,10.1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.307,410.333L475.711,154.911L554.127,200.185L551.627,204.515L475.711,160.685L38.307,413.22L33.307,410.333Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.18207,0,0,2.29185,-364.035,-76.847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.92,182.002L350.44,190.782L386.918,169.722L390.144,158.425L371.63,160.807L334.92,182.002Z",
    style: {
      stroke: "white",
      strokeWidth: "0.83px",
      strokeLinecap: "square",
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.18207,0,0,2.29185,-634.471,87.1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.901,183.168L348.421,191.948L386.918,169.722L390.144,158.425L371.63,160.807L332.901,183.168Z",
    style: {
      stroke: "white",
      strokeWidth: "0.83px",
      strokeLinecap: "square",
      strokeLinejoin: "miter"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.901444,0,0,0.946793,2.65025,10.1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.552,280.292L863.552,283.179L475.711,507.099L397.295,461.826L399.795,457.496L475.711,501.326L858.552,280.292Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.18207,0,0,2.29185,-379.833,-86.4269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.475,154.483L495.742,178.885",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.07px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.18207,0,0,2.29185,-379.833,-86.4269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.806,143.108L433.774,178.885L495.742,143.108L495.742,135.633L433.774,99.856L371.806,135.633L371.806,143.108Z",
    style: {
      fill: "rgb(0,121,107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.18207,0,0,2.29185,-161.861,-218.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.806,143.108L420.589,171.187L482.557,135.409L482.557,127.934L433.774,99.856L371.806,135.633L371.806,143.108Z",
    style: {
      fill: "rgb(255,179,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.18207,0,0,2.29185,-32.4192,-139.913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.806,143.108L420.589,171.187L482.557,135.409L482.557,127.934L433.774,99.856L371.806,135.633L371.806,143.108Z",
    style: {
      fill: "rgb(124,179,66)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-596.364,363.645)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "344.745px",
    style: {
      fontFamily: "'TitilliumWeb-Bold', 'Titillium Web'",
      fontWeight: 700,
      fontSize: "14.25px",
      fill: "rgb(235,235,235)"
    }
  }, "repository")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-667.812,320.32)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "repositoryStats",
    x: "280px",
    y: "322.821px",
    style: {
      fontFamily: "'TitilliumWeb-Regular', 'Titillium Web'",
      fontSize: "9.5px",
      fill: "rgb(235,235,235)"
    }
  }, "repository stats")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-396.817,155.989)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "archiveStats",
    x: "280px",
    y: "322.821px",
    style: {
      fontFamily: "'TitilliumWeb-Regular', 'Titillium Web'",
      fontSize: "9.5px",
      fill: "rgb(235,235,235)"
    }
  }, "archiv", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "303.76px ",
    y: "322.821px "
  }, "e")), " stats")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-177.867,23.2191)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "encStats",
    x: "280px",
    y: "322.821px",
    style: {
      fontFamily: "'TitilliumWeb-Regular', 'Titillium Web'",
      fontSize: "9.5px",
      fill: "rgb(235,235,235)"
    }
  }, "encyclopedia stats")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-48.2806,101.8)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "toolkitStats",
    x: "280px",
    y: "322.821px",
    style: {
      fontFamily: "'TitilliumWeb-Regular', 'Titillium Web'",
      fontSize: "9.5px",
      fill: "rgb(235,235,235)"
    }
  }, "ai toolkit stats")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-468.236,273.281)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "324.526px",
    style: {
      fontFamily: "'TitilliumWeb-Regular', 'Titillium Web'",
      fontSize: "11.875px",
      fill: "white"
    }
  }, "pr", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "290.248px ",
    y: "324.526px "
  }, "o")), "cessing")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-739.332,437.673)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "324.526px",
    style: {
      fontFamily: "'TitilliumWeb-Regular', 'Titillium Web'",
      fontSize: "11.875px",
      fill: "white"
    }
  }, "upload")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-832.377,317.37)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "324.526px",
    style: {
      fontFamily: "'TitilliumWeb-Regular', 'Titillium Web'",
      fontSize: "11.875px"
    }
  }, "explor", _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "310.578px ",
    y: "324.526px "
  }, "e")))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-137.471,258.922)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "320.14px",
    y: "325.332px",
    style: {
      fontFamily: "'TitilliumWeb-Regular', 'Titillium Web'",
      fontSize: "11.875px"
    }
  }, "API")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-325.553,199.427)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "344.745px",
    style: {
      fontFamily: "'TitilliumWeb-Bold', 'Titillium Web'",
      fontWeight: 700,
      fontSize: "14.25px",
      fill: "rgb(235,235,235)"
    }
  }, "archive")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-135.371,48.9883)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "344.745px",
    style: {
      fontFamily: "'TitilliumWeb-Bold', 'Titillium Web'",
      fontWeight: 700,
      fontSize: "14.25px",
      fill: "white"
    }
  }, "ency", _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: "308.514px ",
    y: "344.745px "
  }, "c")), "lopedia")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31481,-0.797294,1.51821,0.920636,-36.3098,109.059)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "336.589px",
    style: {
      fontFamily: "'TitilliumWeb-Bold', 'Titillium Web'",
      fontWeight: 700,
      fontSize: "14.25px",
      fill: "white"
    }
  }, "artificial"), /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "350.839px",
    style: {
      fontFamily: "'TitilliumWeb-Bold', 'Titillium Web'",
      fontWeight: 700,
      fontSize: "14.25px",
      fill: "white"
    }
  }, "intelligence"), /*#__PURE__*/React.createElement("text", {
    x: "280px",
    y: "365.089px",
    style: {
      fontFamily: "'TitilliumWeb-Bold', 'Titillium Web'",
      fontWeight: 700,
      fontSize: "14.25px",
      fill: "white"
    }
  }, "toolkit")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(35.0386,0,0,36.8013,112.044,587.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.232,-0.65C0.249,-0.633 0.269,-0.625 0.291,-0.625C0.313,-0.625 0.333,-0.633 0.35,-0.65C0.367,-0.667 0.375,-0.687 0.375,-0.709C0.375,-0.731 0.367,-0.75 0.35,-0.767C0.333,-0.783 0.313,-0.791 0.291,-0.791C0.269,-0.791 0.25,-0.783 0.233,-0.767C0.217,-0.75 0.209,-0.731 0.209,-0.709C0.209,-0.687 0.217,-0.667 0.232,-0.65ZM0.834,-0.875C0.846,-0.875 0.855,-0.871 0.863,-0.863C0.871,-0.855 0.875,-0.846 0.875,-0.834L0.875,-0.584C0.875,-0.572 0.871,-0.562 0.863,-0.554C0.855,-0.545 0.846,-0.541 0.834,-0.541L0.166,-0.541C0.154,-0.541 0.145,-0.545 0.137,-0.554C0.129,-0.562 0.125,-0.572 0.125,-0.584L0.125,-0.834C0.125,-0.846 0.129,-0.855 0.137,-0.863C0.145,-0.871 0.154,-0.875 0.166,-0.875L0.834,-0.875ZM0.232,-0.232C0.249,-0.217 0.269,-0.209 0.291,-0.209C0.313,-0.209 0.333,-0.217 0.35,-0.233C0.367,-0.25 0.375,-0.269 0.375,-0.291C0.375,-0.313 0.367,-0.333 0.35,-0.35C0.333,-0.367 0.313,-0.375 0.291,-0.375C0.269,-0.375 0.25,-0.367 0.233,-0.35C0.217,-0.333 0.209,-0.313 0.209,-0.291C0.209,-0.269 0.217,-0.249 0.232,-0.232ZM0.834,-0.459C0.846,-0.459 0.855,-0.455 0.863,-0.446C0.871,-0.438 0.875,-0.428 0.875,-0.416L0.875,-0.166C0.875,-0.154 0.871,-0.145 0.863,-0.137C0.855,-0.129 0.846,-0.125 0.834,-0.125L0.166,-0.125C0.154,-0.125 0.145,-0.129 0.137,-0.137C0.129,-0.145 0.125,-0.154 0.125,-0.166L0.125,-0.416C0.125,-0.428 0.129,-0.438 0.137,-0.446C0.145,-0.455 0.154,-0.459 0.166,-0.459L0.834,-0.459Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(38.6852,0,0,40.6314,-1.17035,438.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.264,-0.471C0.3,-0.434 0.344,-0.416 0.396,-0.416C0.449,-0.416 0.493,-0.434 0.529,-0.471C0.566,-0.507 0.584,-0.551 0.584,-0.604C0.584,-0.656 0.566,-0.7 0.529,-0.736C0.493,-0.773 0.449,-0.791 0.396,-0.791C0.344,-0.791 0.3,-0.773 0.264,-0.736C0.227,-0.7 0.209,-0.656 0.209,-0.604C0.209,-0.551 0.227,-0.507 0.264,-0.471ZM0.646,-0.416L0.854,-0.209L0.791,-0.146L0.584,-0.354L0.584,-0.387L0.572,-0.398C0.523,-0.355 0.464,-0.334 0.396,-0.334C0.321,-0.334 0.257,-0.36 0.204,-0.412C0.151,-0.464 0.125,-0.528 0.125,-0.604C0.125,-0.679 0.151,-0.743 0.204,-0.796C0.257,-0.849 0.321,-0.875 0.396,-0.875C0.472,-0.875 0.536,-0.849 0.588,-0.796C0.64,-0.743 0.666,-0.679 0.666,-0.604C0.666,-0.536 0.645,-0.477 0.602,-0.428L0.613,-0.416L0.646,-0.416Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.907222,0,0,0.983302,0.245885,10.1583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "matrix(0.993631,0,0,0.962871,2.65025,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,412.944L17.195,395.308L76.244,360.184L96.747,377.857L34.39,413.859L34.39,448.142L0,448.142L0,412.944Z",
    style: {
      fill: "white",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "matrix(2.40523,0,0,2.33077,-698.41,78.9745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.331,178.885L356.547,196.64L395.044,174.413L390.948,158.89L364.06,156.525L325.331,178.885Z",
    style: {
      fill: "white",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "encyclopedia",
    transform: "matrix(2.40523,0,0,2.33077,-178.719,-250.269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.806,143.108L420.769,171.377L482.737,135.6L433.774,107.331L371.806,143.108Z",
    style: {
      fill: "white",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "toolkit",
    transform: "matrix(2.40523,0,0,2.33077,-20.7432,-162.081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.21,139.3L414.822,167.943L476.79,132.166L427.178,103.523L365.21,139.3Z",
    style: {
      fill: "white",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "api",
    transform: "matrix(0.993631,0,0,0.962871,2.65025,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.874,315.909L833.39,301.196L869.409,280.401L869.409,242.554L922.903,242.554L922.903,276.811L887.712,297.128L858.874,315.909Z",
    style: {
      fill: "white",
      fillOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(35.0386,0,0,36.8013,69.3381,560.079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.834,-0.375L0.834,-0.791L0.166,-0.791L0.166,-0.375L0.834,-0.375ZM0.584,-0.25L0.584,-0.291L0.416,-0.291L0.416,-0.25L0.584,-0.25ZM0.916,-0.25L1,-0.25L1,-0.166L0,-0.166L0,-0.25L0.084,-0.25L0.084,-0.875L0.916,-0.875L0.916,-0.25Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(35.0386,0,0,36.8013,792.965,275.883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.834,-0.375L0.834,-0.791L0.166,-0.791L0.166,-0.375L0.834,-0.375ZM0.584,-0.25L0.584,-0.291L0.416,-0.291L0.416,-0.25L0.584,-0.25ZM0.916,-0.25L1,-0.25L1,-0.166L0,-0.166L0,-0.25L0.084,-0.25L0.084,-0.875L0.916,-0.875L0.916,-0.25Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(35.0386,0,0,36.8013,29.7411,529.218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.279,-0.369C0.356,-0.4 0.43,-0.416 0.5,-0.416C0.57,-0.416 0.644,-0.401 0.72,-0.37C0.796,-0.34 0.834,-0.299 0.834,-0.25L0.834,-0.166L0.166,-0.166L0.166,-0.25C0.166,-0.299 0.204,-0.339 0.279,-0.369ZM0.617,-0.549C0.585,-0.516 0.546,-0.5 0.5,-0.5C0.454,-0.5 0.415,-0.516 0.383,-0.549C0.35,-0.581 0.334,-0.62 0.334,-0.666C0.334,-0.712 0.35,-0.751 0.383,-0.784C0.415,-0.817 0.454,-0.834 0.5,-0.834C0.546,-0.834 0.585,-0.817 0.617,-0.784C0.65,-0.751 0.666,-0.712 0.666,-0.666C0.666,-0.62 0.65,-0.581 0.617,-0.549Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51821,0,0,1.59459,-137.43,-420.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.85,404.535L552.85,415.278L463.786,466.7L463.786,455.956L552.85,404.535Z",
    style: {
      fill: "rgb(0,76,64)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51821,0,0,1.59459,51.77,-570.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.85,404.535L552.85,415.278L463.786,466.7L463.786,455.956L552.85,404.535Z",
    style: {
      fill: "rgb(255,111,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51821,0,0,1.59459,181.468,-491.618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.85,404.535L552.85,415.278L463.786,466.7L463.786,455.956L552.85,404.535Z",
    style: {
      fill: "rgb(51,105,30)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51821,0,0,1.59459,-407.531,-256.447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.629,404.407L552.629,415.151L463.786,466.7L463.786,455.956L552.629,404.407Z",
    style: {
      fill: "rgb(74,0,114)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51821,0,0,1.59459,-137.43,-420.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.786,466.7L374.722,415.278L374.722,404.535L463.786,455.956L463.786,466.7Z",
    style: {
      fill: "rgb(72,169,153)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51821,0,0,1.59459,80.5414,-552.819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.835,455.758L374.722,415.278L374.722,404.535L444.835,445.015L444.835,455.758Z",
    style: {
      fill: "rgb(255,213,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51821,0,0,1.59459,210.076,-474.072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.835,455.758L374.722,415.278L374.722,404.535L444.835,445.015L444.835,455.758Z",
    style: {
      fill: "rgb(174,213,129)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51821,0,0,1.59459,-407.531,-256.447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.786,466.7L374.501,415.151L374.501,404.407L463.786,455.956L463.786,466.7Z",
    style: {
      fill: "rgb(174,82,212)"
    }
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.a4d06242.svg";
export { ForwardRef as ReactComponent };